<mat-sidenav-container class="main-container" [style.marginTop.px]="isMobile() ? 56 : 0">
  <mat-sidenav #snav [mode]="isMobile() ? 'over' : 'side'" class="sidenav" [fixedInViewport]="isMobile()" fixedTopGap="56">
    <mat-nav-list>
      @for (button of pageButtons; track button) {
      <button type="button" mat-button aria-label="button.label" (click)="navClick(button)">
        <mat-icon>{{button.icon}}</mat-icon> {{button.label}}
      </button>
      }
      <button type="button" mat-button (click)="signOut()">
        <mat-icon>logout</mat-icon> Sign Out
      </button>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <button class="menu-toggle" type="button" mat-fab (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>